
import Vue from 'vue'
import { TIME_UNITS } from '@/constants/business'

const validate = (value, { startDate, maxDuration = 10 } = {}) => {
  if (!startDate) return false
  if (!value) return false
  if (Vue.isTestMode()) {
    return true
  }
  const dateEnd = Vue.prototype.$moment(value)
  const dateStart = Vue.prototype.$moment(startDate)
  // длительность сессии не меньше 10 мин
  return dateEnd.diff(dateStart, TIME_UNITS.MINUTES) >= maxDuration
}

export default {
  validate,
  params: ['startDate']
}
